import React, { forwardRef, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
//import jsPDF from "jspdf";

//Services
import * as Service from "../../../services/Service.js";
import Constants from "../../../services/Constants";
import swal from "sweetalert";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Typography,
  TextField,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormHelperText,
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import ExportButtons from "../../../components/ExportButtons";

import { useTranslation } from "react-i18next";

import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "react-query";

import * as api from "../../../actions/api";
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, ViewList, preview, Edit } from "@material-ui/icons";
import { cellFocusEditor } from "../../../services/Common";
import moment from "moment";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";



const IssueDetailsByFacility = (props) => {

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  
  const { t, i18n } = useTranslation();
  const lan = localStorage.getItem("LangCode");
  const FacilityId = localStorage.getItem("FacilityId");
  const FacilityName = localStorage.getItem("FacilityName");
  const menukey = "issue-details-by-facility";
  const UserInfo = sessionStorage.getItem("User_info")
  ? JSON.parse(sessionStorage.getItem("User_info"))
  : 0;
  const UserName = UserInfo == 0 ? "" : UserInfo[0].id;
  const DistrictList = JSON.parse(localStorage.getItem("DistrictList"));
  DistrictList.unshift({'id':0,'name':t(DispensingLanguage[lan][menukey]["All"])});

  const classes = useStyles();
  let tblRef = null;
  const tableRef = useRef();
  const { useState } = React;
  // const [selectedRow, setSelectedRow] = useState(null);
  // const [productsData, selectProductsData] = useState([]);
  // const [productsAllData, selectProductsAllData] = useState([]);
  // const [productGroupData, selectProductGroupData] = useState([]);
  // const [productGroupFilter, selectProductGroupFilter] = useState("0");
  const [firstLoad, setFirstLoad] = useState(true);
  // const [numberRowPerPage, setNumberRowPerPage] = useState(5);
  // const [totalRow, setTotalRow] = useState(0);
  // const [pageNumber, setPageNumber] = useState(0);
  // const [query, setQuery] = useState("");

  // const [TableDataUpdate, setTableDataUpdate] = useState([]);
  const [ManyJsonSave, setInputChange] = useState({});
  //const [radioValue, setRadioValue] = useState(2);
  const [productGroupData, selectProductGroupData] = useState();
  const [dataItems, setDataItems] = useState([]);
  const [currGroupCode, setcurrGroupCode] = useState(0);
  const [currDistCode, setcurrDistCode] = useState(0);

  const [manyTableData, setManyTableData] = useState([]);
  const GroupNameList = JSON.parse(localStorage.getItem("GroupNameList"));
  GroupNameList.unshift({'id':0,'name':t(DispensingLanguage[lan][menukey]["All"])});

  let TempItemList = useState([]);
  const [ItemList, setItemListLocal] = useState(TempItemList);
  const [currItemCode, setcurrItemCode] = useState(0);

  let TempFacilityList = useState([]);
  const [FacilityList, setFacilityListLocal] = useState(TempFacilityList);
  const [currFacilityCode, setcurrFacilityCode] = useState(0);
  const UseFor = localStorage.getItem("UseFor");
  // const UpazilaList = JSON.parse(localStorage.getItem("UpazilaList"));
  let TempUpazillaList = useState([]);
  const [UpazilaList, setUpazillaListLocal] = useState(TempUpazillaList);
  const [currUpazillaId, setUpazillaId] = useState(UpazilaList.length>0? UpazilaList[0].id:"");
  const [currUpazillaName, setUpazillaName] = useState(UpazilaList.length>0? UpazilaList[0].name:"");

   
//====== Start Choosen Dropdown===========
const [chosenValues, setChosenValues] = useState({
  "GroupCode": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
});
const [chosenValuesItem, setChosenValuesItem] = useState({
  "ItemCode": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
});

const [chosenValuesDistrict, setChosenValuesDistrict] = useState({
  "DistCode": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
});
const [chosenValuesFacility, setChosenValuesFacility] = useState({
  "FacilityCode": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
});

const [chosenValuesUpazilla, setChosenValuesUpazilla] = useState({
  "WhID": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
});

const handleChangeChoosen = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValues};
  chosenValuesData[name] = valueobj;
  setChosenValues(chosenValuesData); 

  setFirstLoad(true);
  setLoading(false);
  setcurrGroupCode(value);

};

const handleChangeChoosenItem = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValuesItem};
  chosenValuesData[name] = valueobj;
  setChosenValuesItem(chosenValuesData); 

  setFirstLoad(true);
  setLoading(false);
  setcurrItemCode(value);

};



const handleChangeChoosenDistrict = (name, valueobj, value) => {
  let chosenValuesDataDistrict = { ...chosenValuesDistrict};
  chosenValuesDataDistrict[name] = valueobj;
  setChosenValuesDistrict(chosenValuesDataDistrict); 
  //setcurrFacilityCode(0);
  setFirstLoad(true);
  setLoading(false);
  setcurrDistCode(value);

};

const handleChangeChoosenFacility = (name, valueobj, value) => {
  let chosenValuesDataFacility = { ...chosenValuesFacility};
  chosenValuesDataFacility[name] = valueobj;
  setChosenValuesFacility(chosenValuesDataFacility); 

  setFirstLoad(true);
  setLoading(false);
  setcurrFacilityCode(value);

};

//====== End Choosen Dropdown===========

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    moment().subtract(30, "days").format("YYYY-MM-01")
  );

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    moment().format("YYYY-MM-DD")
  );

  
  const handleStartDateChange = (date) => {
    setFirstLoad(true);
    setLoading(true);
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setFirstLoad(true);
    setLoading(true);
    setSelectedEndDate(date);
  };


  const cItemList = () => {  
    
    let ItemListParam = {action:"ItemList", GroupCode:currGroupCode, FacilityId: FacilityId, menukey:""}

    Service.default
        .postApi("source/combo_generic.php",ItemListParam)
        .then((res) => { 

          let All_Item_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All"])};
          const Item_List = [All_Item_label].concat(res.datalist); 

          setChosenValuesItem({
           "ItemCode": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
          }); 

          setItemListLocal(Item_List);
          
        })
        .catch((err) => {});
  
}


const cUpazillaList = () => {  
    
  let ItemListParam = {action:"UpazillaListGlobal", DistCode:currDistCode, menukey:""}

  Service.default
      .postApi("source/combo_generic.php",ItemListParam)
      .then((res) => { 

        let All_Upazilla_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All"])};
        const Upazilla_List = [All_Upazilla_label].concat(res.datalist); 

        setChosenValuesUpazilla({
          "WhID": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
        }); 

        setUpazillaListLocal(Upazilla_List);
       
       
      })
      .catch((err) => {});

}

  const cFacilityList = () => {  
    
    let FacilityListParam = {action:"FacilityListForUpazilaGlobal",  DistCode:0, FacilityId: currUpazillaId, menukey:"", UseFor:UseFor}

    Service.default
        .postApi("source/combo_generic.php",FacilityListParam)
        .then((res) => { 

          
          let All_Facility_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All"])};
          const Facility_List = [All_Facility_label].concat(res.datalist); 

          setChosenValuesFacility({
           "FacilityCode": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
          }); 

          setFacilityListLocal(Facility_List);
          //setFacilityListLocal(res.datalist); 
        })
        .catch((err) => {});
  
}

const handleChangeChoosenWareHouse = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValuesUpazilla};
  chosenValuesData[name] = valueobj;

  setFirstLoad(true);
  setLoading(false);
  setChosenValuesUpazilla(chosenValuesData);
  setUpazillaId(value); 
  setUpazillaName(valueobj.name);



};


  const queryClient = useQueryClient();

  let params = {
    menukey: menukey,
    FacilityId: currUpazillaId,
    action: "getDataListGlobal",
    StartDate: moment(selectedStartDate).format("YYYY-MM-DD"),
    EndDate: moment(selectedEndDate).format("YYYY-MM-DD"),
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    //RadioValue: radioValue,
    GroupCode: currGroupCode,
    DistCode: currDistCode,
    ItemCode: currItemCode,
    FacilityCode: currFacilityCode,
  };

  const [isLoading, setLoading] = useState(false);

  const { error, isError, data, refetch:stockData } = useQuery(
    [params],
    api.IssueDetailsByFacility,
    {
      onSuccess: (data) => {
        if(firstLoad){
          /* localStorage.setItem(
            "StockData",
            JSON.stringify(data)
          ); */
          
          setDataItems(data);
          setLoading(false);
          setFirstLoad(false);
        }
      },
        refetchOnWindowFocus: false,
        refetchOnmount: false,
        refetchOnReconnect: false,
        retry: false,
        staleTime: 0
  }
  ); 


  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let formatedDate = moment(selectedStartDate).format("YYYY-MM-DD");
    let EndDate = moment(selectedEndDate).format("YYYY-MM-DD");
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";

    window.open(
      finalUrl +
        "?action=IssueDetailsByFacilityExcelExportGlobal" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&StartDate=" +
        formatedDate +
        "&EndDate=" +
        EndDate +
        "&FacilityId=" +
        currUpazillaId +
        "&GroupCode=" +
        currGroupCode +
        "&DistCode=" +
        currDistCode +
        "&ItemCode=" +
        currItemCode +
        "&FacilityCode=" +
        currFacilityCode +
        "&UseFor=" +
        UseFor +
        "&FacilityName=" +
        currUpazillaName + "&TimeStamp=" + Date.now()
    );
  };
  /* =====End of Excel Export Code==== */


  const columns = [
    {
      title: "Id",
      field: "id",
      visible: false,
    },
    {
      title: DispensingLanguage[lan][menukey]["Sl#"],
      hozAlign: "center",
      width: "80",
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: DispensingLanguage[lan][menukey]["Item Code"],
      field: "ItemCode",
      headerFilter: false,
      width: "100",
    },
   /*  {
      title: DispensingLanguage[lan][menukey]["Group Name"],
      field: "GroupName",
      headerFilter: false,
      visible: false,
    }, */
   
    {
      title: DispensingLanguage[lan][menukey]["Item Name"],
      field: "ItemName",
      headerFilter: true,
      minWidth: 200,
     // width: "25%",
    }, 
    {
      title: DispensingLanguage[lan][menukey]["Invoice No"],
      field: "InvoiceType",
      headerFilter: false,
      width: "100",

    },
    {
      title: DispensingLanguage[lan][menukey]["Invoice Date"],
      field: "StockDate",
      headerFilter: false,
      width: "100",

    },
    {
      title: DispensingLanguage[lan][menukey]["Issue Qty"],
      field: "TotQtyOut",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: "100",
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();

        return value == 0 ? "" : Number(value).toLocaleString();
      },

    },
    {
      title: DispensingLanguage[lan][menukey]["Lot No/Description"],
      field: "LotNo",
      headerFilter: false,
      width: "100",

    },

    {
      title: DispensingLanguage[lan][menukey]["Mfg Date"],
      field: "MfgDate",
      headerFilter: false,
      width: "100",

    },

    {
      title: DispensingLanguage[lan][menukey]["Exp Date"],
      field: "ExpDate",
      headerFilter: false,
      width: "100",

    },
    /* 
    {
      title: DispensingLanguage[lan][menukey]["Unusable Qty"],
      field: "UnusableQty",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: "15%",
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == 0 ? "" : value;
      },
    }, 
 */
  ];



  const checkLogin = () => {
    let token = Constants.token;

    if (!token) {
      swal("Oops!", `token expired. Please login again`, "error");
      props.history.push("/login");
    }
  };


  /* const changeRadio = (value) => {
    setFirstLoad(true);
    setLoading(true);
    setRadioValue(value);
  }; */

  React.useEffect(() => {
    setcurrItemCode(0); 
    cItemList();
  }, [currGroupCode]);


  
  React.useEffect(() => {
    setcurrFacilityCode(0); 
    cUpazillaList();
  }, [currDistCode]);

  React.useEffect(() => {
    setcurrFacilityCode(0); 
    cFacilityList();
  }, [currUpazillaId]);


 React.useEffect(() => {
   if (tblRef == null) return;
   setLoading(true);
   stockData();
  }, [selectedStartDate, selectedEndDate, currGroupCode, currDistCode, currItemCode, currFacilityCode]);

  return (
    <>
      <div className={classes.productPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Issue Details by Facility"]}
              </div>
            </div>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
          <Grid item xs={12} sm={12}>
            <Grid container spacing={1}>
            <Grid item xs={2} sm={2}>
                <FormControl className={classes.fullWidth}>
                

                        <Autocomplete
                          autoHighlight
                          disabled={
                            manyTableData.length > 0 ? true : props.bStockUpdate
                          }
                          disableClearable
                          id="DistCode"
                          options={DistrictList}
                          onChange={(event, valueobj) => handleChangeChoosenDistrict('DistCode', valueobj, valueobj?valueobj.id:"")}
                          getOptionLabel={(option) => option.name}
                          value={chosenValuesDistrict['DistCode']}
                          renderOption={(option) => (
                          <Typography className="sw_fontSize">{option.name}</Typography>
                          )}
                          renderInput={(params) => (
                          <TextField
                            {...params}
                            //value={props.formData.DistCode}
                            label={DispensingLanguage[lan][menukey]["District"]}
                            variant="standard"
                            id="DistCode"
                            name="DistCode"
                            fullWidth
                          />
                          )}
                        />
                </FormControl>
              </Grid>

              <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                     

                        <Autocomplete
                          autoHighlight
                          disableClearable
                          id="WhID"
                          options={UpazilaList}
                          onChange={(event, valueobj) => handleChangeChoosenWareHouse('WhID', valueobj, valueobj?valueobj.id:"")}
                          getOptionLabel={(option) => option.name}
                          value={chosenValuesUpazilla['WhID']}
                          renderOption={(option) => (
                          <Typography className="sw_fontSize">{option.name}</Typography>
                          )}
                          renderInput={(params) => (
                          <TextField
                            {...params}
                          
                            label={DispensingLanguage[lan][menukey]["Upazila"]}
                            variant="standard"
                            id="WhID"
                            name="WhID"
                            fullWidth
                          />
                          )}
                        />

                    </FormControl>
                  </Grid>


              <Grid item xs={3} sm={3}>
                    <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                           
                            disableClearable
                            id="FacilityCode"
                            options={FacilityList}
                            onChange={(event, valueobj) => handleChangeChoosenFacility('FacilityCode', valueobj, valueobj?valueobj.id:"")}
                            getOptionLabel={(option) => option.name}
                            value={chosenValuesFacility['FacilityCode']}
                            renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.name}</Typography>
                            )}
                            renderInput={(params) => (
                            <TextField
                              {...params}
                              label={DispensingLanguage[lan][menukey]["Facility"]}
                              variant="standard"
                              id="FacilityCode"
                              name="FacilityCode"
                              fullWidth
                            />
                            )}
                          />

                    </FormControl>
                  </Grid> 

              <Grid item xs={2} sm={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justifyContent="space-around">
                    <KeyboardDatePicker
                      className={classes.fullWidth}
                      //disableToolbar
                      autoOk={true}
                      // disabled={true}
                      variant="inline"
                      format="dd/MM/yyyy"
                      id="date-picker-inline"
                      label={DispensingLanguage[lan][menukey]["Start Date"]}
                      value={selectedStartDate}
                      onChange={handleStartDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={2} sm={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justifyContent="space-around">
                    <KeyboardDatePicker
                      className={classes.fullWidth}
                      variant="inline"
                      format="dd/MM/yyyy"
                      id="date-picker-inline"
                      label={DispensingLanguage[lan][menukey]["End Date"]}
                      autoOk={true}
                      value={selectedEndDate}
                      onChange={handleEndDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>



                  <Grid item xs={1} sm={1}>
                      <div className="float-right sw_btn_control">

                      <ExportButtons PrintPDFExcelExportFunction={PrintPDFExcelExportFunction}  {...props}></ExportButtons>
                        {/* <Button
                          color="info"
                          className="mr-2 sw_icons"
                          onClick={() => PrintPDFExcelExportFunction("print")}
                        >
                          <i class="fas fa-print"></i>
                        </Button>

                        <Button
                          color="info"
                          className="mr-2 sw_icons"
                          onClick={() => PrintPDFExcelExportFunction("excel")}
                        >
                          <i className="far fa-file-excel"></i>
                        </Button> */}
                      </div>
                    </Grid>
               
            </Grid>


            <Grid item xs={12} sm={12}>
            <Grid container spacing={2} className={classes.customControlSpacing}>
              
               

            <Grid item xs={3} sm={3}>
                <FormControl className={classes.fullWidth}>
                  {/* <InputLabel id="">
                    {DispensingLanguage[lan][menukey]["Group"]} 
                  </InputLabel>
                  <Select
                   // error={props.errorObject.SupCode}
                    labelId="GroupCode"
                    id="GroupCode"
                    name="GroupCode"
                   // value={'CON'}
                    value={currGroupCode}
                    fullWidth
                    onChange={handleChange}
                    disabled={
                      manyTableData.length > 0 ? true : props.bStockUpdate
                    }
                  >
                   
                   <MenuItem value="0"> {DispensingLanguage[lan][menukey]["All"]}</MenuItem>
                    {GroupNameList.map((item, index) => {
                      return (
                        <MenuItem value={item.id}>{item.name}</MenuItem>
                      );
                    })}
                  </Select> */}

                        <Autocomplete
                          autoHighlight
                          disabled={
                            manyTableData.length > 0 ? true : props.bStockUpdate
                          }
                          disableClearable
                          id="GroupCode"
                          options={GroupNameList}
                          onChange={(event, valueobj) => handleChangeChoosen('GroupCode', valueobj, valueobj?valueobj.id:"")}
                          getOptionLabel={(option) => option.name}
                          value={chosenValues['GroupCode']}
                          renderOption={(option) => (
                          <Typography className="sw_fontSize">{option.name}</Typography>
                          )}
                          renderInput={(params) => (
                          <TextField
                            {...params}
                            //value={props.formData.GroupCode}
                            label={DispensingLanguage[lan][menukey]["Group"]}
                            variant="standard"
                            id="GroupCode"
                            name="GroupCode"
                            fullWidth
                          />
                          )}
                        />

                </FormControl>
                  </Grid>

                   <Grid item xs={4} sm={4}>
                    <FormControl className={classes.fullWidth}>
                    

                          <Autocomplete
                            autoHighlight
                          
                            disableClearable
                            id="ItemCode"
                            options={ItemList}
                            onChange={(event, valueobj) => handleChangeChoosenItem('ItemCode', valueobj, valueobj?valueobj.id:"")}
                            getOptionLabel={(option) => option.name}
                            value={chosenValuesItem['ItemCode']}
                            renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.name}</Typography>
                            )}
                            renderInput={(params) => (
                            <TextField
                              {...params}
                              label={DispensingLanguage[lan][menukey]["Item"]}
                              variant="standard"
                              id="ItemCode"
                              name="ItemCode"
                              fullWidth
                            />
                            )}
                          />

                    </FormControl>
                  </Grid> 
              


              {/* <Grid item xs={8} sm={12}>
                <FormControl component="fieldset" className="mt-3 ml-3">
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="row-radio-buttons-group"
                    defaultValue="SHOW_NONE_ZERO"
                  >
                    
                    <FormControlLabel
                      value="Show_Only_Usable_Stock"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["Show Only Usable Stock"]}
                      onClick={() => changeRadio(3)}
                    />
                    <FormControlLabel
                      value="SHOW_NONE_ZERO"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["Show Only Non-Zero Stock"]}
                      onClick={() => changeRadio(2)}
                    />
                    
                    <FormControlLabel
                      value="SHOW_ZERO"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["Show Only Zero Stock"]}
                      onClick={() => changeRadio(1)}
                    />
                    <FormControlLabel
                      value="SHOW_ALL"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["Show All Items"]}
                      onClick={() => changeRadio(0)}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid> */}


            </Grid>

            </Grid> 
               
            </Grid>
            
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}

          <div className="uniqueName">
            <ReactTabulator
              ref={(r) => (tblRef = r)}
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height="400px"
              // groupBy="GroupName"
              options={{
                  groupBy: "Receiver",
                  columnCalcs: "both",
                }}
             // rowDblClick={(e, row) => tableRowDoubleClick(e, row)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default IssueDetailsByFacility;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  customControlSpacing: {
    padding: "0.3rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
